import React from "react";
import { useQuery } from 'react-query'
import Phase from 'components/common/selectors/selector-phase/Phase';
import NotAvailable from 'components/common/NotAvailable'
import { useUrlFriendlyToParameters, useGetPath } from "helpers/urlFriendly";
import { useGetConfigSports } from 'helpers/commonCodes';
import { getEventRSC } from "helpers/rsc"
import { getPhases, getAllGames } from "data/Querys"
import Label from "components/general/Label";
import UnitsSlide from "../../selector-unit/Unit";
import useViewport from "components/general/useViewPort";

export default function PhaseContainer() {
    const { breakPoint } = useViewport();
    const { mirs_rsc, mirs_language, mirs_competition, mirs_discipline } = useUrlFriendlyToParameters();
    const params = { 'mirs_competition': mirs_competition, 'mirs_discipline': mirs_discipline };
    const dataConfigSport = useGetConfigSports(params);
    const _event = getEventRSC(mirs_rsc);
    const obj = useGetPath()
    const objUrl = obj(mirs_language);
    const labelSwimOff = Label({ data: "SwimOff" });
    const sw = dataConfigSport?.hasRibbon === false ? false : true;
    const isH2H = dataConfigSport?.isH2H === true ? true : false;
    const isMobile = (breakPoint === "sm" || breakPoint === "xs")



    //Load data Phases
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['phasesData', mirs_competition, mirs_language, _event],
            queryFn: getPhases,
            refetchInterval: 0,
            //cacheTime: 30000, //TIME TO REMOVE FROM MEMORY defeult 5 min
            //staleTime: Infinity, //staleTime determines for how long a certain response will still be considered fresh (or not stale), dismissing the need for a new request.
        });




    const { data: dataGames, isError: isErrorGames, isLoading: isLoadingGames } = useQuery(
        {
            queryKey: ['AllGames', mirs_competition, mirs_discipline, mirs_language],
            queryFn: getAllGames,
            refetchInterval: 60000,
            //cacheTime: 300000, //TIME TO REMOVE FROM MEMORY defeult 5 min
            staleTime: 50000,//Infinity, //staleTime determines for how long a certain response will still be considered fresh (or not stale), dismissing the need for a new request.
            enabled: isH2H && mirs_competition !== "EG2023" && !isMobile
        });


    if (isError) { return <NotAvailable />; }
    if (isLoading) { return (''); }
    if (!data) { return (<div className='container'><NotAvailable /></div>); }

    //EVENTS FILTER 
    let units;

    // swim-off units 
    data.forEach((phase, index) => {
        units = phase?.units?.filter(item => item?.code.endsWith('RR--'));
        if (Array.isArray(units) && units.length > 0) {
            let phaseFilter = data.find(item => item.code === phase.code.substring(0, phase.code.length - 2) + "RR")
            if (!phaseFilter) {
                let h = { ...phase };
                h.order = Number(h.order) - 0.5;
                h.shortDescription = phase.shortDescription + " " + labelSwimOff;
                h.code = phase.code.substring(0, phase.code.length - 2) + "RR";
                if (mirs_discipline === 'SWM') { data.push(h); }
            }
        }
    })


    return (
        sw && <section className='container-navigation-phase-units'>
            <Phase items={data} extraData={dataConfigSport} />
            {mirs_competition !== "EG2023" && !isMobile && objUrl.url.isResult && isH2H && <UnitsSlide items={dataGames} />}
        </section>

    )

}

